import { AxiosResponse } from 'axios';
import { NextApiRequestQuery } from 'next/dist/server/api-utils';
import { fetcherFull, MethodEnum } from 'utils/helpers/browser/newFetcher';
import { AddressApiInterface, DisciplineEnum } from 'submodules/api_middleware';
import fetcher from 'utils/helpers/browser/fetcher';

export const getMemberList = async (
    query: NextApiRequestQuery
): Promise<AxiosResponse> => {
    return await fetcherFull('/api/member/list', MethodEnum.GET, {
        ...query,
    });
};

export const getMemberPaymentInformation = async (
    id: number,
    discipline: DisciplineEnum
): Promise<AxiosResponse> => {
    return await fetcherFull(
        `/api/member/${id}/payment-information`,
        MethodEnum.GET,
        {
            discipline,
        }
    );
};

export const getAddress = async (): Promise<AddressApiInterface | false> => {
    /* The disadvantage of newFetcher is that it displays an error message when query not successful.
     * We don't want that, since the th copy o address is just a nice to have feature.
     * That's why we use the older implementation of fetcher
     */
    const response: AxiosResponse = await fetcher(
        `/api/member/address`,
        MethodEnum.GET,
        {}
    );

    if (response.status !== 200) {
        return false;
    }
    const json = response.data.data;
    return {
        city: json.city,
        country_code: json.country_code,
        created_at: json.created_at,
        first_line: json.first_line,
        id: json.id,
        postal_code: json.postal_code,
        street: json.street,
        street_number: json.street_number,
        updated_at: json.updated_at,
    };
};
